import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchInvoice = (params, id) => api.request(1, `/invoiceDatas/${id || ''}`, MethodType.GET, params)

export const addInvoice = params => api.request(1, '/invoiceDatas', MethodType.POST, params)

export const modInvoice = (id, params) => api.request(1, `/invoiceDatas/${id}`, MethodType.PATCH, params)

export const delInvoice = (id, params) => api.request(1, `/invoiceDatas/${id}`, MethodType.DELETE, params)

export const downloadInvoice = (id, params) => api.request(1, `/invoiceDataDownload/${id}`, MethodType.GET, params, {}, false, { responseType: 'blob' })

export const fetchInvoiceLimit = (groupId, params) => api.request(1, `/invoiceDataCount/${groupId}`, MethodType.GET, params)

// ----- options -----
export const fetchInvoiceRuleOptions = (type, params) => api.request(1, `/invoiceRuleOptions/${type || ''}`, MethodType.GET, params)

export const previewInvoice = params => api.request(1, '/invoiceDataPreview', MethodType.POST, params)

export const checkFileInvoice = params => api.request(1, '/invoiceDataCheckFile', MethodType.POST, params, {}, false, {}, [422])

// ----- invoice segment -----
export const fetchInvoiceSegment = (params, id) => api.request(1, `/invoiceSegments/${id || ''}`, MethodType.GET, params)

export const addInvoiceSegment = params => api.request(1, '/invoiceSegments', MethodType.POST, params)

export const modInvoiceSegment = (id, params) => api.request(1, `/invoiceSegments/${id}`, MethodType.PATCH, params)

export const delInvoiceSegment = (id, params) => api.request(1, `/invoiceSegments/${id}`, MethodType.DELETE, params)
